import React, { useCallback, useEffect, useState } from 'react';
import api from '../services/api';
import { messaggioDa, notificaErrore } from '../utils/notifiche';
import '../styles/Segnalazioni.css';

/**
 * Segnalazioni — Sistema → Segnalazioni (migration 346, proposta del
 * 28/10/2026, da confermare da Alex il 2/11).
 *
 * La voce c'e' per l'amministrazione, ma la LEGGE solo chi ha il permesso
 * dedicato (segnalazioni_lettori, per utente): il server risponde 403 agli
 * altri, e la schermata lo dice invece di mostrare un elenco vuoto. A modulo
 * spento dice che non e' attivo.
 *
 * La copia della pagina contiene dati di pazienti: si apre solo con «Apri la
 * copia della pagina», in una scheda nuova, e ogni apertura va nel Registro
 * degli accessi. L'elenco non la chiede.
 */
const MSG_SPENTO = 'Le segnalazioni non sono attive.';
const MSG_PERMESSO = 'Le segnalazioni le legge solo chi ha il permesso.';
const STATI = { aperta: 'Aperta', presa: 'Presa', chiusa: 'Chiusa' };

const dataOra = (v) => (v ? new Date(v).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'medium' }) : '—');
const ora = (t) => (Number.isFinite(t) ? new Date(t).toLocaleTimeString('it-IT') : '—');

function Dettaglio({ id, aggiorna }) {
    const [d, setD] = useState(null);
    const [nota, setNota] = useState('');
    const [lavoro, setLavoro] = useState(false);
    const carica = useCallback(() => {
        api.get(`/segnalazioni/${id}`).then((r) => setD(r.data.data))
            .catch((e) => notificaErrore(messaggioDa(e, 'Non riesco a leggere la segnalazione.')));
    }, [id]);
    useEffect(() => { setD(null); setNota(''); carica(); }, [carica]);

    const gesto = async (cosa) => {
        setLavoro(true);
        try {
            await api.post(`/segnalazioni/${id}/${cosa}`, cosa === 'chiudi' ? { nota: nota.trim() || null } : {});
            carica();
            aggiorna();
        } catch (e) {
            notificaErrore(messaggioDa(e, 'La segnalazione non si è aggiornata.'));
        } finally {
            setLavoro(false);
        }
    };
    const apriCopia = async () => {
        try {
            const r = await api.get(`/segnalazioni/${id}/copia`);
            window.open(r.data.data.url, '_blank', 'noopener');
        } catch (e) {
            notificaErrore(messaggioDa(e, 'Non riesco ad aprire la copia della pagina.'));
        }
    };

    if (!d) return <div className="seg-dettaglio">Caricamento…</div>;
    const vociRegistro = d.registro?.voci || [];
    return (
        <div className="seg-dettaglio">
            <h2 className="seg-dettaglio-titolo">{d.codice}</h2>
            <dl className="seg-dati">
                <dt>Quando</dt><dd>{dataOra(d.creata_il)}</dd>
                <dt>Chi</dt><dd>{d.segnalata_da || '—'} ({d.ruolo})</dd>
                <dt>Pagina</dt><dd className="seg-mono">{d.percorso}</dd>
                <dt>Versione</dt><dd className="seg-mono">{d.versione || '—'}</dd>
                <dt>Finestra</dt><dd>{d.registro?.finestra?.l || '—'} × {d.registro?.finestra?.a || '—'} · stile {d.registro?.stile || '—'}</dd>
                <dt>Stato</dt><dd>{STATI[d.stato]}{d.presa_da ? ` · presa da ${d.presa_da}` : ''}{d.chiusa_da ? ` · chiusa da ${d.chiusa_da}` : ''}</dd>
                {d.nota_chiusura && (<><dt>Nota</dt><dd>{d.nota_chiusura}</dd></>)}
            </dl>
            <h3 className="seg-sezione">Che cosa stava facendo</h3>
            <p className="seg-testo-libero">{d.testo || '—'}</p>
            <h3 className="seg-sezione">Copia della pagina</h3>
            {d.ha_copia ? (
                <p>
                    <button type="button" className="seg-secondario" onClick={apriCopia}>Apri la copia della pagina</button>
                    <span className="seg-scade"> si distrugge il {dataOra(d.copia_scade_il)}</span>
                </p>
            ) : (
                <p className="seg-nota">{d.copia_tolta_il ? `Scaduta e distrutta il ${dataOra(d.copia_tolta_il)}.` : 'Nessuna copia allegata.'}</p>
            )}
            <h3 className="seg-sezione">Registro tecnico ({vociRegistro.length} voci)</h3>
            <div className="rm-scorre">
                <table className="seg-tabella">
                    <thead><tr><th>Ora</th><th>Tipo</th><th>Cosa</th><th>Stato</th><th>ms</th></tr></thead>
                    <tbody>
                        {vociRegistro.map((v, i) => (
                            <tr key={`${v.t}-${i}`} className={v.k === 'err' || (v.k === 'api' && v.s >= 400) ? 'seg-riga-errore' : ''}>
                                <td className="seg-mono">{ora(v.t)}</td>
                                <td>{v.k === 'nav' ? 'pagina' : v.k === 'api' ? 'chiamata' : 'errore'}</td>
                                <td className="seg-mono">{v.k === 'api' ? `${v.m} ${v.p}` : v.k === 'nav' ? v.p : `${v.msg}${v.pila ? ` — ${v.pila}` : ''}`}</td>
                                <td className="seg-mono">{v.k === 'api' ? v.s : ''}</td>
                                <td className="seg-mono">{v.k === 'api' && v.ms !== null ? v.ms : ''}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {d.stato !== 'chiusa' && (
                <div className="seg-gesti">
                    {d.stato === 'aperta' && (
                        <button type="button" className="seg-secondario" disabled={lavoro} onClick={() => gesto('prendi')}>Prendi</button>
                    )}
                    <input type="text" className="seg-nota-campo" maxLength={300} placeholder="Una riga di nota (facoltativa)"
                        value={nota} onChange={(e) => setNota(e.target.value)} disabled={lavoro} />
                    <button type="button" className="seg-primario" disabled={lavoro} onClick={() => gesto('chiudi')}>Chiudi</button>
                </div>
            )}
        </div>
    );
}

export default function Segnalazioni() {
    const [stato, setStato] = useState(null);
    const [elenco, setElenco] = useState([]);
    const [filtro, setFiltro] = useState('');
    const [scelta, setScelta] = useState(null);

    useEffect(() => {
        api.get('/segnalazioni/stato').then((r) => setStato(r.data.data))
            .catch(() => setStato({ errore: true }));
    }, []);
    const carica = useCallback(() => {
        api.get('/segnalazioni', { params: filtro ? { stato: filtro } : {} })
            .then((r) => setElenco(r.data.data.segnalazioni))
            .catch((e) => notificaErrore(messaggioDa(e, 'Non riesco a leggere le segnalazioni.')));
    }, [filtro]);
    useEffect(() => { if (stato?.legge) carica(); }, [stato, carica]);

    let corpo;
    if (!stato) corpo = <p>Caricamento…</p>;
    else if (stato.errore) corpo = <p className="seg-errore">Non riesco a sapere se le segnalazioni sono attive.</p>;
    else if (!stato.attivo) corpo = <p className="seg-nota">{MSG_SPENTO}</p>;
    else if (!stato.legge) corpo = <p className="seg-nota">{MSG_PERMESSO}</p>;
    else {
        corpo = (
            <>
                <div className="seg-filtri">
                    <label>
                        Stato{' '}
                        <select value={filtro} onChange={(e) => { setFiltro(e.target.value); setScelta(null); }} data-non-trattiene="">
                            <option value="">Tutte</option>
                            <option value="aperta">Aperte</option>
                            <option value="presa">Prese</option>
                            <option value="chiusa">Chiuse</option>
                        </select>
                    </label>
                </div>
                <div className="rm-scorre">
                    <table className="seg-tabella">
                        <thead><tr><th>Codice</th><th>Quando</th><th>Ruolo</th><th>Pagina</th><th>Versione</th><th>Stato</th><th>Presa da</th></tr></thead>
                        <tbody>
                            {elenco.length === 0 && <tr><td colSpan={7}>Nessuna segnalazione.</td></tr>}
                            {elenco.map((s) => (
                                <tr key={s.id} className={scelta === s.id ? 'seg-riga-scelta' : ''}>
                                    <td><button type="button" className="seg-collegamento" onClick={() => setScelta(s.id)}>{s.codice}</button></td>
                                    <td className="seg-mono">{dataOra(s.creata_il)}</td>
                                    <td>{s.ruolo}</td>
                                    <td className="seg-mono">{s.percorso}</td>
                                    <td className="seg-mono">{s.versione || '—'}</td>
                                    <td>{STATI[s.stato]}</td>
                                    <td>{s.presa_da || '—'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {scelta && <Dettaglio id={scelta} aggiorna={carica} />}
            </>
        );
    }
    return (
        <div className="seg-pagina">
            <h1 className="seg-titolo-pagina">Segnalazioni</h1>
            {corpo}
        </div>
    );
}
